import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
import {OpeningHour} from '@app/domain/opening-hour';


@Injectable({
    providedIn: 'root'
})
export class OpeningHourService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    findAll(params: string = ''): Observable<OpeningHour[]> {
        return this.http.get<OpeningHour[]>(this.withQuery(`${this.baseUrl}/opening-hours`, params));
    }

    findAllForCompany(idEmpresa: number, params: string = ''): Observable<OpeningHour[]> {
        return this.http.get<OpeningHour[]>(this.withQuery(
            `${this.baseUrl}/root/companies/${idEmpresa}/opening-hours`, params));
    }

    findById(id): Observable<OpeningHour> {
        return this.http.get<OpeningHour>(`${this.baseUrl}/opening-hours/${id}`);
    }

    findByIdForCompany(idEmpresa: number, id: number): Observable<OpeningHour> {
        return this.http.get<OpeningHour>(
            `${this.baseUrl}/root/companies/${idEmpresa}/opening-hours/${id}`);
    }

    save(model: OpeningHour): Observable<OpeningHour> {
        return this.http.post<OpeningHour>(`${this.baseUrl}/opening-hours`, model);
    }

    saveForCompany(idEmpresa: number, model: OpeningHour): Observable<OpeningHour> {
        return this.http.post<OpeningHour>(
            `${this.baseUrl}/root/companies/${idEmpresa}/opening-hours`, model);
    }

    update(id, model: OpeningHour): Observable<OpeningHour> {
        return this.http.put<OpeningHour>(`${this.baseUrl}/opening-hours/${id}`, model);
    }

    updateForCompany(idEmpresa: number, id: number, model: OpeningHour): Observable<OpeningHour> {
        return this.http.put<OpeningHour>(
            `${this.baseUrl}/root/companies/${idEmpresa}/opening-hours/${id}`, model);
    }

    delete(id): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/opening-hours/${id}`);
    }

    deleteForCompany(idEmpresa: number, id: number): Observable<void> {
        return this.http.delete<void>(
            `${this.baseUrl}/root/companies/${idEmpresa}/opening-hours/${id}`);
    }

    private withQuery(url: string, params: string): string {
        const query = (params || '').trim();
        return query ? `${url}?${query}` : url;
    }
}
